// components/FeedbackWidget.js
// PointFeedback-knop voor beheerders. Bewust NIET voor fotografen: die werken
// op de scanner in het productieproces en hebben hun eigen /feedback-scherm
// voor afgekeurde foto's. Deze knop gaat over de app zelf — wat kapot is of
// beter kan — en komt terecht bij Stratalytic, mét console-, netwerk- en
// sessiecontext zodat een fix direct oppakbaar is.
//
// Op de scanner (de Capacitor-shell/APK in de fabriek, of de oude TWA in
// tabletmodus) verschijnt de knop nooit, ook niet als daar een Admin inlogt:
// dat scherm is voor foto's, niet voor feedback over de app.
//
// De widget zet zijn knop zelf op 16px van de onderrand en kent alleen een
// hoek als optie (bottom-right/bottom-left), geen offset. Op een telefoon
// staat hij daarmee midden in de tabbalk. Daarom krijgt de wortel van de
// widget een klasse en tilt index.css hem boven de tabbalk uit; <html> krijgt
// een klasse zodat de laatste rij content onder de knop vandaan kan scrollen.
import { useEffect } from 'react';
import { init } from '@pointfeedback/widget';
import { useAuth } from '../contexts/AuthContext';
import { isTabletMode } from '../utils/tabletMode';
import { hasNativeUploader } from '../utils/nativeBridge';

const ADMIN_ROLE = 'Admin';
const LAUNCHER_CLASS = 'feedback-launcher';
const PAGE_CLASS = 'has-feedback-launcher';

export default function FeedbackWidget() {
  const { user } = useAuth();
  const projectKey = process.env.REACT_APP_POINTFEEDBACK_KEY;
  const apiUrl = process.env.REACT_APP_POINTFEEDBACK_URL;
  const isAdmin = user?.role === ADMIN_ROLE;
  const userId = user?.id;

  useEffect(() => {
    // Zonder key geen knop, nooit voor niet-beheerders, en nooit op de scanner.
    if (!projectKey || !isAdmin) return;
    if (isTabletMode() || hasNativeUploader()) return;

    const instance = init({
      projectKey,
      apiUrl,
      user: { id: String(userId), name: user?.full_name, email: user?.email },
      accentColor: '#111827',
    });
    // De widget hangt zijn wortel (position: fixed) direct onder <body>; de
    // wijs-hint en de markering komen pas later en alleen tijdens het aanwijzen.
    document.querySelector('body > [data-pf-widget]')?.classList.add(LAUNCHER_CLASS);
    document.documentElement.classList.add(PAGE_CLASS);
    return () => {
      document.documentElement.classList.remove(PAGE_CLASS);
      instance.destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectKey, apiUrl, isAdmin, userId]);

  return null;
}
